import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/(dashboard)/dashboard/$program/encounters')({
  component: () => (
    <Outlet />
  ),
  errorComponent: ({ error }: { error: Error }) => (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <div className="text-center">
        <h1 className="text-2xl font-bold">Encounters Page Error</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
})

